import { HeatmapGradientType } from '@app/modules/cop/drawing/visualizations/heatmap';

export enum VisualizationLayerType {
  Heatmap = 0
}

export interface VisualizationLayerOptions {
  visualizationType: VisualizationLayerType;
}

export interface HeatmapOptions extends VisualizationLayerOptions {
  heatmapGradientType?: HeatmapGradientType;
  heatmapOpacity?: number;
  heatmapRadius?: number;
}
